import React from 'react';
import ReviewsSection from '../sections/ReviewsSection';

export default function ReviewsPage({ reviews, onMessageWhatsApp }) {
  return <ReviewsSection reviews={reviews} onMessageWhatsApp={onMessageWhatsApp} />;
}
